import { render, staticRenderFns } from "./lc.vue?vue&type=template&id=a1eb040e&scoped=true"
import script from "./lc.vue?vue&type=script&lang=js"
export * from "./lc.vue?vue&type=script&lang=js"
import style0 from "./lc.vue?vue&type=style&index=0&id=a1eb040e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1eb040e",
  null
  
)

export default component.exports